import React, { useState, useEffect } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { Menu, X, Search } from 'lucide-react';
import { brand, nav } from '../mock/mockData';

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [location.pathname]);

  return (
    <header className={`fixed top-0 inset-x-0 z-40 transition-all duration-500 ${scrolled ? 'bg-forest-950/95 backdrop-blur-sm py-3 shadow-lg shadow-black/30' : 'bg-transparent py-6'}`}>
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between">
        <Link to="/" className="flex items-start gap-3 group" aria-label={brand.name}>
          <span className="block">
            <span className="font-serif text-cream-50 text-lg md:text-[22px] tracking-[0.06em] leading-[0.98] font-semibold group-hover:text-sage-400 transition-colors block">
              <span className="block">PERRIN</span>
              <span className="block">MYDDELTON</span>
            </span>
            <span className="block mt-1 text-[9px] md:text-[10px] tracking-[0.18em] uppercase text-cream-100/55 group-hover:text-cream-100/75 transition-colors">A trading name of Hedges Law</span>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-9">
          {nav.map((item) => (
            <NavLink
              key={item.href}
              to={item.href}
              className={({ isActive }) => `link-underline text-[15px] tracking-wide transition-colors ${isActive ? 'text-sage-400' : 'text-cream-100/85 hover:text-cream-50'}`}
            >
              {item.label}
            </NavLink>
          ))}
          <button aria-label="Search" className="text-cream-100/80 hover:text-sage-400 transition-colors">
            <Search className="h-4 w-4" />
          </button>
        </nav>

        <button className="lg:hidden text-cream-100" onClick={() => setOpen((v) => !v)} aria-label="Toggle menu">
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-forest-950/98 backdrop-blur border-t border-forest-700">
          <div className="px-6 py-6 flex flex-col gap-4">
            {nav.map((item) => (
              <Link key={item.href} to={item.href} className="text-cream-100 text-lg py-2 border-b border-forest-700">
                {item.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
